import {
    myadvisor,
    getDataByLectureAcademic,
    store,
    update,
    destroy,
    destroyAcademic,
    getUnlistStudent,
    multistoreAcademic,
    ListOfLecture,
    getData,
    uploadExcel,
    getStudentsAdvisor
} from '@/store/api/AdvisorController'
const initialState = () => ({
    allstudents: {last_page: 0,data: [], total: 0},
    students: {},
    unlistStudents: [],
    autocomplete: [],
    lecture: {},
    lectureQuota: {},
    advisors: {
        'akademik': null,
        'kerja-praktek': null,
        'magang': null,
        'ppta': null,
        'tugas-akhir-1': null,
        'tugas-akhir-2': null
    },
    response: {},
    request:{
        page: 1,
        show: 10,
        sortBy: null,
        sorting: "DESC",
        search: null,
        semester: null,
        activeTab: null,
        filter: 1
    },
})
const state = initialState


const getters = {
    getAllStudents: state => state.allstudents,
    getAutoComplete: state => state.autocomplete,
    getAdvisors: state => state.advisors,
    getStudents: state => state.students,
    getLecture: state => state.lecture,
    getLectureQuota: state => state.lectureQuota,
    getRequest: state => state.request,
    getUnlistStudents: state => state.unlistStudents,
    getResponse: state => state.response
}

const actions = {
    async ListOfLecture({commit }, url) 
    {
        try {
            var response = await ListOfLecture(url);
            commit('SET_AUTOCOMPLETE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getMyadvisor({commit }, semester) 
    {
        try {
            var response = await myadvisor({semester: semester});
            commit('SET_MYADVISORS', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    // Akademik
    async getDataByLectureAcademic({commit }, {request, id}) 
    {
        try {
            state.request = request
            var response = await getDataByLectureAcademic(request, id);
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getStudentsAdvisor({commit }, {request, url}) 
    {
        try {
            state.request = request
            var response = await getStudentsAdvisor(request, url);
            commit('SET_ALLDATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getData({commit }, {request, url}) 
    {
        try {
            state.request = request
            var response = await getData(request, url);
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getUnlistStudent({commit }, url) 
    {
        try {
            var response = await getUnlistStudent(url);
            commit('SET_UNLISTSTUDENTS', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async uploadExcel({commit }, {data, url}) 
    {
        try {
            var response = await uploadExcel(data, url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async store({commit }, {data, url}) 
    {
        try {
            var response = await store(data, url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async multistoreAcademic({commit }, data) 
    {
        try {
            var response = await multistoreAcademic(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async update({commit }, {data, id, url}) 
    {
        try {
            var response = await update(data, id, url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async destroy({commit }, {id, url}) 
    {
        try {
            var response = await destroy(id, url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async destroyAcademic({commit }, {id, lecture_id}) 
    {
        try {
            var response = await destroyAcademic(id, lecture_id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.response = {
            msg: 'Jaringan Bermasalah',
            status: '0'
        }
    },
    SET_RESPONSE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
    },
    SET_ALLDATA(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.allstudents = response.data
    },
    SET_DATA(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.students = response.data.students
        state.lecture = response.data.lecture
        state.lectureQuota = response.data.quota
    },
    SET_UNLISTSTUDENTS(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.unlistStudents = response.data
    },
    SET_MYADVISORS(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.advisors = response.data
    },
    SET_AUTOCOMPLETE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.autocomplete = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}